import _ from 'underscore'
import $ from 'jquery'
import Swiper from '@/swiper-bundle'
import {
  Controller,
  EffectCoverflow,
  Keyboard,
  Pagination
} from 'swiper/modules'
import 'swiper/less/controller'
import 'swiper/less/effect-coverflow'
import 'swiper/less/keyboard'
import 'swiper/less/pagination'
import { track } from '@/analytics/trackAsync'

/**
 * Returns a Swiper instance for the product hero carousel,
 * or `null` if there isn't one because the SSR DOM elements don't exist.
 */
export const initializeSwiperHero = _.once(() =>
  $('#hero-img-carousel .swiper-slide').length
    ? new Swiper('#hero-img-carousel .swiper', {
        modules: [Controller, EffectCoverflow, Keyboard, Pagination],
        pagination: {
          el: '#hero-img-carousel .swiper-pagination',
          clickable: true
        },
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          slideShadows: false
        },
        slideToClickedSlide: true,
        keyboard: {
          enabled: true,
          // Disable PageUp/PageDown keys to prevent interference with default page scrolling
          pageUpDown: false
        },
        on: {
          slideChange(this: Swiper) {
            const currentSlide = this.slides[this.activeIndex]
            if (currentSlide) {
              track(
                'Viewed Carousel Slide',
                {
                  category: 'Product Page',
                  label: String(this.activeIndex),
                  viewName: $(currentSlide).find('img').data('viewName')
                },
                {
                  integrations: {
                    woopra: true
                  }
                }
              )
            }
          }
        }
      })
    : null
)
